// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3fbe603f","667":"3e6e2a49"}[chunkId] + ".chunk.js";
};